import React from 'react'
import styled from 'styled-components'

const LogoContainer = styled.div`
  height: 28px;
  margin: 16px;
  display: flex;
  align-items: center;
`

const LogoContainer2 = styled.div`
  height: 28px;
  margin: 16px 8px;
  display: flex;
  align-items: center;
`

const LogoImage = styled.img`
  height: 100%;
  width: auto;
  object-fit: contain;
`

const Logo = ({ collapsed }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    }}>
      <LogoImage
        src="/logo512.png"
        alt="Wise Academy Logo"
        style={{
          maxWidth: collapsed ? '32px' : '120px',
          height: collapsed ? '32px' : 'auto',
          transition: 'all 0.2s ease'
        }}
      />
    </div>
  )
}

export default Logo
